import { bindable, computedFrom } from 'aurelia-framework';

class ProductFeedsProductsContainer {
  /**
   * The basic information of the customer account.
   * @type {?AccountInformation}
   */
  @bindable selectedAccount = null;
  @bindable onViewProduct = () => {};
  /**
   * Whether or not the container is loading information.
   * @type {Boolean}
   */
  loading = false;
  searchQuery = '';
  tableColumns = [
    {
      id: 'name',
      title: 'Product',
      details: [
        {
          fallback: 'null',
          id: 'status',
          title: 'Status',
        },
        {
          fallback: 'null',
          id: 'id',
          title: 'ID',
        },
        {
          fallback: 'null',
          id: 'parent_id',
          maxWidth: 300,
          title: 'Parent ID',
        },
        {
          fallback: 'null',
          id: 'tag_based_key',
          maxWidth: 300,
          title: 'Tag Based Key',
        },
        {
          fallback: 'URL Unavailable',
          id: 'product_url',
          link: true,
          title: 'Product URL',
        },
      ],
      thumbnail: {
        id: 'base_image',
        link: true,
        title: 'Thumbnail',
      },
      sortEnabled: true,
    },
    {
      id: 'actions',
      sortEnabled: false,
      title: 'Actions',
    },
  ];
  tableActions = [
    {
      id: 'view',
      title: 'View',
    },
  ];
  _mainList = null;
  _searchList = null;
  _searchBoxInput = null;
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsProducts} productFeedsProducts To get FeedsProducts.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productFeedsProductsErrorParser = errorParser.wrap();
    this._productFeedsProducts = productFeedsProducts;
  }
  changeSort(column) {
    let asc = true;
    if (this._mainList.sortBy === column) {
      asc = !this._mainList.sortAsc;
    }
    this._mainList.sort(column, asc);
    this._searchList.sort(column, asc);

    const refresh = [this._mainList.loadProducts()];
    if (this.searchQuery) {
      refresh.push(this._searchList.loadProducts());
    }

    return Promise.all(refresh)
    .catch((error) => {
      const parsedError = this._productFeedsProductsErrorParser(error, 'There was an error loading the products');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  moveToTheNextPage() {
    this.productsList.moveToTheNextPage()
    .catch((error) => {
      const parsedError = this._productFeedsProductsErrorParser(error, 'There was an error loading the products');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  moveToThePreviousPage() {
    this.productsList.moveToThePreviousPage()
    .catch((error) => {
      const parsedError = this._productFeedsProductsErrorParser(error, 'There was an error loading the products');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  saveSearchBoxRef(ref) {
    this._searchBoxInput = ref.input;
  }
  search(text) {
    if (text !== this.searchQuery) {
      this.searchQuery = text;
      if (this.searchQuery) {
        const list = this.productsList;

        list
        .reset()
        .search(this.searchQuery)
        .loadProducts()
        .then(() => {
          if (this._searchBoxInput) {
            /**
             * I debugged this like crazy and there's no way to set the focus on
             * Chrome (and Chrome-like browsers) without a timeout.
             */
            const neededTimeBeforeTheBrowserAllowsTheFocus = 100;
            setTimeout(() => {
              this._searchBoxInput.focus();
            }, neededTimeBeforeTheBrowserAllowsTheFocus);
          }
        })
        .catch((error) => {
          const parsedError = this._productFeedsProductsErrorParser(
            error,
            'There was an error loading the search results',
          );

          this._appErrorPublisher.notify(error, parsedError.message);
        });
      }
    }
  }
  selectedAccountChanged() {
    this._mainList = this._productFeedsProducts.newList(this.selectedAccount.id);
    this._mainList.loadProducts()
    .catch((error) => {
      const parsedError = this._productFeedsProductsErrorParser(error, 'There was an error loading the products');

      this._appErrorPublisher.notify(error, parsedError.message);
    });

    this._searchList = this._productFeedsProducts.newList(this.selectedAccount.id);
  }
  @computedFrom('searchQuery')
  get productsList() {
    let result = null;
    if (this._mainList) {
      result = this.searchQuery ? this._searchList : this._mainList;
    }

    return result;
  }
}

export { ProductFeedsProductsContainer };
